/* raw layout hash: _users-groups-roles-layout:523ca4f27cae2c4e9ba7d85dbf26c64acb4fe21d2780005233c15c6479045672 */
import DefaultWebShell from './components/DefaultWebShell.jsx';

/**
 * Layout `_users-groups-roles-layout`
 * Source shell: RawHTMLDesign/layouts/_users-groups-roles-layout.html
 *
 * Despite the name, this shell carries the same chrome as `_default-web-layout`
 * — fixed-top navbar with the full menuData navigation, the `<!-- main content -->`
 * outlet and the empty footer. Its raw shell differs from `_default-web-layout`
 * only by deferring stylesheets to the page's `<!-- page import style -->` slot.
 * It is NOT a users-and-roles-specific sidebar/sub-nav shell, so none is invented
 * here.
 *
 * Pages using this layout: Users & Roles, Results & Variants (both authenticated
 * → signed-in details + log out in the navbar).
 */
export default function UsersGroupsRolesLayout({ children }) {
  return <DefaultWebShell>{children}</DefaultWebShell>;
}
